import React from "react";
import AddressBook from "./component/AddressBook";
import {createRoot} from "react-dom/client";

export default () => {

    const dom = document.querySelector('[data-address-book]');
    if (dom) {
        const root = createRoot(dom);
        root.render(<AddressBook
            base={dom.getAttribute('data-base')}
        />);
    }

}
